import styled from 'styled-components';

export const Container = styled.div`
  margin: 10px;
  padding-left: 25px;
  padding-right: 25px;
  @media only screen and (max-width: 100px) {
  }
`;
